export var Actions;
(function (Actions) {
    Actions["GET_LIST"] = "getAssessmentListAction";
    Actions["GET_DETAIL"] = "getAssessmentDetailAction";
    Actions["POST_DATA"] = "postAssessmentAction";
    Actions["UPDATE_DATA"] = "putAssessmentAction";
    Actions["DELETE_DATA"] = "deleteAssessmentAction";
    Actions["GET_FORM_DATA"] = "getAssessmentFormData";
    Actions["POST_FORM_DATA"] = "postAssessmentFormData";
    Actions["UPDATE_FORM_DATA"] = "putAssessmentFormData";
    Actions["APPROVAL_FORM_DATA"] = "approvalAssessmentFormData";
    Actions["UPDATE_CERTIFICATIE"] = "putAssessmentCertificateAction";
    Actions["GET_PURPOSE_LIST"] = "getAssessmentPurposeListAction";
    Actions["GET_SCHEDULE"] = "getAssessmentScheduleAction";
    Actions["POST_SCHEDULE"] = "postAssessmentScheduleAction";
    Actions["UPDATE_SCHEDULE"] = "updateAssessmentScheduleAction";
    Actions["GET_SCHEDULE_LIST"] = "getAssessmentScheduleListAction";
    Actions["EXPORT_ASSESSMENT_SCHEDULE"] = "exportAssessmentScheduleListAction";
    Actions["DOWNLOAD_ASSESSMENT_SCHEDULE"] = "downloadAssessmentScheduleListAction";
    Actions["GET_BINDING_FORM_LIST"] = "getAssessmentBindingFormListAction";
    Actions["VIEW_BINDING_DETAIL"] = "getAssessmentBindingDetailAction";
    Actions["DOWNLOAD_ALL_DOCUMENT"] = "postAssessmentBindingFormDownloadAllAction";
    Actions["GET_ASSESSMENT_SCHEME"] = "getAssessmentSchemeAction";
    Actions["GET_ASSESSMENT_TEST_PLACE"] = "getAssessmentTestPlaceAction";
    Actions["GET_ASSESSMENT_ASSESOR"] = "getAssessmentAssesorAction";
    Actions["GET_ASSESSMENT_SCHEDULE_AVAILABILITIES"] = "getAsessmentScheduleAvailbilities";
})(Actions || (Actions = {}));
export var Mutations;
(function (Mutations) {
    Mutations["SET_ASSESSMENT_LIST"] = "setAssessmentListMutation";
    Mutations["SET_ASSESSMENT_LIST_LOADING"] = "setAssessmentListLoadingMutation";
    Mutations["SET_ASSESSMENT_LIST_PAGINATION_LOADING"] = "setAssessmentListPaginationLoadingMutation";
    Mutations["SET_ASSESSMENT_LIST_PAGINATION"] = "setAssessmentListPaginationMutation";
    Mutations["SET_ASSESSMENT_LIST_FILTER"] = "setAssessmentListFilterMutation";
    Mutations["RESET_ASSESSMENT_LIST_FILTER"] = "resetAssessmentListFilterMutation";
    Mutations["SET_ASSESSMENT_LIST_MODAL_LOADING"] = "setAssessmentListModalLoadingMutation";
    Mutations["SET_FILTER"] = "setAssessmentListFilterMutation";
    Mutations["CLEAR_FILTER"] = "clearAssessmentScheduleListFilterMutation";
    Mutations["SET_SCHEDULE_LIST"] = "setAssessmentScheduleListMutation";
    Mutations["SET_ASSESSMENT_SCHEDULE_FILTER"] = "setAssessmentScheduleFilterMutation";
    Mutations["SET_FORM_BINDING_LIST"] = "setAssessmentFormBindingListMutation";
    Mutations["SET_ORDER"] = "setAssessmentScheduleListOrderByMutation";
})(Mutations || (Mutations = {}));
export var AssessmentStage;
(function (AssessmentStage) {
    AssessmentStage["PersonalData"] = "PersonalData";
    AssessmentStage["SelfAssessment"] = "SelfAssessment";
    AssessmentStage["PreAssessment"] = "PreAssessment";
    AssessmentStage["Assessment"] = "Assessment";
    AssessmentStage["ResultAndRecomendation"] = "Result";
    AssessmentStage["Certification"] = "Certification";
    AssessmentStage["DetailResult"] = "DetailResult";
    AssessmentStage["Appeal"] = "Appeal";
})(AssessmentStage || (AssessmentStage = {}));
export var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus["Draft"] = "Draft";
    ApprovalStatus["WaitingReviewByAdmin"] = "WaitingReviewByAdmin";
    ApprovalStatus["ApprovedByAdmin"] = "ApprovedByAdmin";
    ApprovalStatus["RevisedByAdmin"] = "RevisedByAdmin";
    ApprovalStatus["RejectedByAdmin"] = "RejectedByAdmin";
    ApprovalStatus["WaitingActionByAdmin"] = "WaitingActionByAdmin";
    ApprovalStatus["WaitingReviewByAsesor"] = "WaitingReviewByAsesor";
    ApprovalStatus["ApprovedByAsesor"] = "ApprovedByAsesor";
    ApprovalStatus["RejectedByAsesor"] = "RejectedByAsesor";
    ApprovalStatus["WaitingActionByAsesor"] = "WaitingActionByAsesor";
    ApprovalStatus["WaitingActionByAsesi"] = "WaitingActionByAsesi";
    ApprovalStatus["Completed"] = "Completed";
    ApprovalStatus["Closed"] = "Closed";
    ApprovalStatus["Certification"] = "Certification";
})(ApprovalStatus || (ApprovalStatus = {}));
